export default __webpack_public_path__ + "static/media/h8.65e3eb52.jpg";